export { default, createFilterOptions } from './Autocomplete';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/Autocomplete/index.js
// module id = 280
// module chunks = 0